<template>
    <div id="residence-agreement">
        <v-card eleation="0" v-if="showAgreement() == true">
            <v-card-title>
                King’s University College Residence Agreement
            </v-card-title>
            <v-card-text>
                This Residence Agreement (the “Agreement”) is entered into by the undersigned student (“Student”) and King’s University College at Western University (“the College” or “King’s”).
            </v-card-text>
            <v-card-text>
                By signing below, I, <span class="applicant__commonname">{{ item.firstName }} {{ item.lastName }}</span>, agree to the following terms and conditions:
            </v-card-text>
            <v-card-text class="font-weight-bold">1. Eligibility</v-card-text>
            <v-card-text>
                The Student affirms that they are registered as a full-time student (or equivalent) at King’s University College, the University of Western Ontario or Huron University College. 
                Should the Student cease to meet this requirement, the College reserves the right to terminate the Student’s residency. 
                In such cases, the Student agrees to vacate the residence upon notice by the Residence and Conference Services Office (“RCSO”).
            </v-card-text>
            <v-card-text class="font-weight-bold">2. Fees</v-card-text>
            <v-card-text>
                The Student agrees to pay all applicable residence fees, meal plan fees (where required), and incidental fees in accordance with the College’s published Fee Schedule.
            </v-card-text>
            <v-card-text class="font-weight-bold">3. Term of Residence</v-card-text>
            <v-card-text>
                The term of this Agreement extends from Labour Day until the earlier of: <br />
                (a) twenty-four (24) hours after the Student’s final exam, or <br />
                (b) the final day of the examination period as indicated in the College’s academic calendar.
            </v-card-text>
            <v-card-text>
                Residence is closed during the December holiday period unless the Student receives written permission to remain from the RCSO. 
                Separate arrangements are required for accommodation between May and August through King’s Conference Services.
            </v-card-text>
            <v-card-text class="font-weight-bold">4. Early Termination and Refunds</v-card-text>
            <v-card-text>
                If the Student leaves residence prior to the end of the term, they remain responsible for all fees unless formally released from the Agreement by the Dean of Students. 
                Deposits and incidental fees are non-refundable. 
                Refunds for room and meal plan fees are calculated based on the College’s refund schedule and policy (12% declining balance method), available on the College website. No exceptions.
            </v-card-text>
            <v-card-text class="font-weight-bold">5. Meal Plan Requirement</v-card-text>
            <v-card-text>
                Meal plans are mandatory for residents of Alumni Court, Townhouses, Wemple. Meal plans are optional for residents of International House Epworth Place Houses and King’s Commons Apartments.
            </v-card-text>
            <v-card-text class="font-weight-bold">6. Room Use and Conditions</v-card-text>
            <v-card-text>
                The Student acknowledges that residence space is licensed, not owned, and that the College retains possession and control at all times. 
                The Student agrees to comply with the following: <br />
                (a) The King’s Rules of Residence (including Rules of Residence – Houses and Apartments), the Residence Network Use Agreement, and the Alcohol Policy; <br />
                (b) All directives, notices, and policies issued by the RCLO and Residence Staff; <br />
                (c) The rulings of any residence disciplinary authority; <br />
                (d) All relevant College and University policies, and directions issued by King’s Security or the Western Special Constable Service.
            </v-card-text>
            <v-card-text>
                The RCSO reserves right to:
                <ul>
                    <li>Reassign rooms at its sole discretion;</li>
                    <li>Enter the room at any time for maintenance, cleaning, or policy compliance;</li>
                    <li>Levy charges for any damages caused by the Student or their guests;</li>
                    <li>Impose disciplinary fines or fees where applicable.</li>
                </ul>
            </v-card-text>
            <v-card-text class="font-weight-bold">7. Limitation of Liability</v-card-text>
            <v-card-text>
                The Student waives all claims against the College and its representatives for any loss, damage, or injury resulting from: theft, fire, accidents, natural disasters, or enforcement/non-enforcement of College policies.
            </v-card-text>
            <v-card-text class="font-weight-bold">8. Indemnification</v-card-text>
            <v-card-text>
                The Student agrees to indemnify and hold harmless the College, its successors, and assigns from any claims, losses, or legal proceedings arising from breaches of the rules noted in Section 6. This obligation binds the Student’s heirs and personal representatives.
            </v-card-text>
            <v-card-text class="font-weight-bold">9. Athletics and Recreation</v-card-text>
            <v-card-text>
                The Student understands the inherent risks associated with athletic and recreational activities and confirms their physical fitness to participate. 
                The Student waives liability against the College for any related injury or loss and agrees to indemnify the College for any resulting claims.
            </v-card-text>
            <v-card-text class="font-weight-bold">10. Academic Standing Verification</v-card-text>
            <v-card-text>
                The Student authorizes the RCLO and/or the Dean of Students to access their academic records to verify eligibility for residence.
            </v-card-text>
            <v-card-text class="font-weight-bold">11. Breach and Termination</v-card-text>
            <v-card-text>
                A breach of any provision of this Agreement may result in termination of residency. Upon notice, the Student agrees to vacate the premises and remove all belongings by the specified time.
            </v-card-text>
            <v-card-text class="font-weight-bold">12. Students Under Age of Majority</v-card-text>
            <v-card-text>
                If the Student is under the age of majority, the College may contact the Student’s parent(s) or legal guardian regarding any matter related to this Agreement.
            </v-card-text>
            <v-card-text class="font-weight-bold">13. Acknowledgment and Agreement</v-card-text>
            <v-card-text>
                By signing below, the Student confirms that they have read, understood, and agreed to all terms and conditions in this Agreement. All students, regardless of age, are encouraged to discuss this Agreement with a parent or guardian prior to signing.
            </v-card-text>
            <v-card-title class="pb-0">
                Applicant
            </v-card-title>
            <v-card-text class="pt-0 pb-0">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.lastName" label="Surname" prepend-icon="mdi-pencil"
                                placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.firstName" label="Given Names" prepend-icon="mdi-pencil"
                                placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.residenceAgreement.applicantSignature" label="Signature"
                                prepend-icon="mdi-draw" placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.residenceAgreement.applicantSignatureDate" label="Date (YYYY-MM-DD)"
                                prepend-icon="mdi-calendar-check" placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-title v-if="!getAgeVerification">
                Parent(s) or Legal Guardian(s)
            </v-card-title>
            <v-card-subtitle v-if="!getAgeVerification">
                Applicants under 18 years of age must have Parent(s) or Legal Guardian(s) complete this section of
                the form.
            </v-card-subtitle>
            <v-card-text v-if="!getAgeVerification" class="pt-0 pb-0">
                In consideration of King’s University College agreeing to accept the above-named student as a
                resident,
                the undersigned agrees as follows:
                <ol>
                    <li>I am the parent/legal guardian of the above-named student; and</li>
                    <li>I will be responsible for and will assume all of the obligations and liabilities of the
                        above-named student in relation to the foregoing Agreement.</li>
                </ol>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.residenceAgreement.parentSurname" label="Surname"
                                prepend-icon="mdi-pencil" placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.residenceAgreement.parentGivenNames" label="Given Names"
                                prepend-icon="mdi-pencil" placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.residenceAgreement.parentPhone" label="Telephone Number"
                                prepend-icon="mdi-phone" placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.residenceAgreement.parentMail" label="Email Address"
                                prepend-icon="mdi-email" placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.residenceAgreement.parentSignature" label="Signature"
                                prepend-icon="mdi-draw" placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.residenceAgreement.parentSignatureDate" label="Date"
                                prepend-icon="mdi-calendar-check" placeholder="Not Available" readonly>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card elevation="0" v-if="showAgreement() == false">
            <v-card-text>
                <v-row>
                    <v-col cols="12"> </v-col>
                    <v-col cols="12">
                        Upon review and approval of the application, and receipt of the required deposit, students will be issued a lease for signature.
                    </v-col>
                    <v-col cols="12"> </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'application-residence-agreement-v2',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data(){
        return {
            showagreement: true
        }
    },
    computed: {
        getAgeVerification() {
            let dob = '';
            let myDate = new Date();
            let currentDate;
            currentDate = (myDate.getFullYear() - 18) + ('0' + (myDate.getMonth() + 1)).slice(-2) + ('0' + myDate.getDate()).slice(-2);

            if (this.item.dateOfBirth) {
                dob = this.item.dateOfBirth.replace(/\D/g, '');

                if (parseInt(dob) <= parseInt(currentDate)) {
                    return true;
                }
            }

            return false;
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGrey() {
            return '#6d6e71';
        },
        successColor() {
            return '#1bc5bd';
        }
    },
    methods: {
        showAgreement(){
            const that = this;

            let createdTimestamp = that.item.createdTimestamp;
            let cutoffDate = 0;

            //Update Nov 7, 2025
            //If submitted before Nov 14 00:00 AM (1763096401), show Agreement even if it's upper year
            
            if(location.hostname == 'mykings.ca'){
                cutoffDate = 1763096401; //2025 Nov 14 00:00:01
            }else {
                cutoffDate = 1762542000; //2025 Nov 07 14:00:00
            }

            if(parseInt(createdTimestamp) >= parseInt(cutoffDate)){

                let buildingOption1 = false
                let buildingOption2 = false
                let upperyears = ["2", "3", "4"]
                let isUpperYear = false

                buildingOption1 = that.item.buildingOption01 != "" && (/Epworth Place/i.test(that.item.buildingOption01) || /King's Commons/i.test(that.item.buildingOption01)) ? true : false
                buildingOption2 = that.item.buildingOption02 != "" && (/Epworth Place/i.test(that.item.buildingOption02) || /King's Commons/i.test(that.item.buildingOption02)) ? true : false
                isUpperYear = that.item.yearOfStudy != "" && upperyears.includes(that.item.yearOfStudy)

                if ((buildingOption1 || buildingOption2) && isUpperYear){
                    return false
                }
            }

            return true
        }
    }
}
</script>

<style scoped>
.applicant__commonname {
    font-size: 20px;
    font-weight: bold;
    text-decoration: underline;
}

.col-12 {
    padding-bottom: 0;
    padding-top: 0;
}

div {
    color: black;
    line-height: 1.8;
}
</style>